import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_enterShip } from './taskEnterShip'
import { createTask_mine } from './taskMine'
import { createTask_moveTo } from './taskMoveTo'
import { createTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { jobs } from './jobs-sidecar'
import { IBlueprint } from '../blueprints/blueprints'
import { asteroids } from '../entities/asteroids-sidecar'
import { createTask_putAway } from './taskPutAway'

export const register = () => registerJob('mine', advanceJob_mine)

export function create(blueprint: IBlueprint) {
  let j = jobs.create('mine')
  j.i = blueprint.i
  j.j = blueprint.j
  j.blueprint = blueprint
  // asteroid not guaranteed
  let as = asteroids.findAtSpot(
    blueprint.i,
    blueprint.j,
    (c) => c.supplyLeft > 0,
  )
  j.asteroid = as
  return j
}

function advanceJob_mine(job: IJob) {
  jobLogger.assertJobType(job, 'mine')

  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []

    // Go to asteroid
    let task = createTask_moveTo(job.i, job.j, false, true)
    job.tasks.push(task)

    // Mine
    task = createTask_mine(job.i, job.j)
    job.tasks.push(task)

    task = createTask_putAway(job.i, job.j)
    job.tasks.push(task)
    // // Go inside
    // task = createTask_enterShip(m.i, m.j)
    // job.tasks.push(task)

    // // Put down in open spot
    // task = createTask_placeInEmptySpace(m.i, m.j)
    // job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
// export function advanceJob_moveToStack(job: IJob) {}
